import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: calc(100% - 20px);
	margin: 0;
	color: ${({ theme }) => theme.color.input.code.text};
	border-left: 1px solid ${({ theme }) => theme.color.input.code.border};
	padding: 0 10px;
`
